/*
  Al Tauheed Textiles: time-based support number.
  08:00:00–19:59:59 → +92 325 8308686, 20:00:00–07:59:59 → +92 321 8308661, always in Pakistan time
  (Asia/Karachi), whatever the visitor's own time zone. The Liquid markup ships +92 325 8308686 as the
  static fallback; this script swaps in the number on duty and switches by itself at 8 AM and 8 PM.

  What it updates (number only, no team names or hours are shown):
  - [data-tt-team-number]: text
  - every link to either number (wa.me / api.whatsapp.com / tel:): href, plus the number in its
    text, title and aria-label (menus, rich text and the footer included)

  Testing: TTSupport.teamAt(date), TTSupport.simulate('19:59:55') / TTSupport.simulate(null).
  On an unpublished theme preview, ?tt_pkt=20:00 simulates a Pakistan time as well.
*/
(function () {
  var TZ = 'Asia/Karachi';
  var MORNING_START = 8 * 3600;
  var EVENING_START = 20 * 3600;
  var TEAMS = {
    morning: { number: '+92 325 8308686', digits: '923258308686' },
    evening: { number: '+92 321 8308661', digits: '923218308661' }
  };
  var TEAM_RE = /(?:\+?92|0)?\s?(3258308686|3218308661|325\s8308686|321\s8308661)/;
  var TEXT_RE = /\+92 325 8308686|\+92 321 8308661/g;

  var formatter = null;
  try {
    formatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: TZ, hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    });
  } catch (e) {
    formatter = null;
  }

  /* Seconds since midnight in Pakistan for a timestamp (ms). */
  function pkSeconds(ms) {
    if (formatter && formatter.formatToParts) {
      var parts = formatter.formatToParts(new Date(ms));
      var v = {};
      for (var i = 0; i < parts.length; i++) v[parts[i].type] = parseInt(parts[i].value, 10);
      return (v.hour % 24) * 3600 + v.minute * 60 + v.second;
    }
    /* Fallback: Pakistan Standard Time is UTC+5 all year (no daylight saving). */
    return Math.floor((ms / 1000 + 5 * 3600) % 86400 + 86400) % 86400;
  }

  function teamAt(ms) {
    var s = pkSeconds(typeof ms === 'number' ? ms : +ms);
    return s >= MORNING_START && s < EVENING_START ? 'morning' : 'evening';
  }

  /* Seconds until the next 8 AM / 8 PM switch. */
  function secondsToSwitch(ms) {
    var s = pkSeconds(ms);
    if (s < MORNING_START) return MORNING_START - s;
    if (s < EVENING_START) return EVENING_START - s;
    return 86400 - s + MORNING_START;
  }

  var offset = 0;
  function now() { return Date.now() + offset; }

  function swapText(str, team) {
    return str.replace(TEXT_RE, team.number);
  }

  function updateLink(a, team) {
    var href = a.getAttribute('href') || '';
    var next = href;
    if (/^tel:/i.test(href)) {
      next = 'tel:+' + team.digits;
    } else {
      next = href.replace(/(wa\.me\/|phone=)(?:\+|%2B)?(?:92|0)?(3258308686|3218308661)/i, '$1' + team.digits);
    }
    if (next !== href) a.setAttribute('href', next);
    ['title', 'aria-label'].forEach(function (attr) {
      var val = a.getAttribute(attr);
      if (val) {
        var swapped = swapText(val, team);
        if (swapped !== val) a.setAttribute(attr, swapped);
      }
    });
    var walker = document.createTreeWalker(a, NodeFilter.SHOW_TEXT, null, false);
    var node;
    while ((node = walker.nextNode())) {
      var t = swapText(node.nodeValue, team);
      if (t !== node.nodeValue) node.nodeValue = t;
    }
  }

  var current = null;
  function apply(key) {
    var team = TEAMS[key];
    if (!team) return;
    current = key;
    document.documentElement.setAttribute('data-tt-team', key);
    var els = document.querySelectorAll('[data-tt-team-number]');
    for (var j = 0; j < els.length; j++) if (els[j].textContent !== team.number) els[j].textContent = team.number;
    var links = document.querySelectorAll('a[href*="wa.me/"], a[href*="whatsapp.com/send"], a[href^="tel:"]');
    for (var i = 0; i < links.length; i++) {
      var h = links[i].getAttribute('href') || '';
      try { h = decodeURIComponent(h); } catch (e) {}
      if (TEAM_RE.test(h)) updateLink(links[i], team);
    }
    document.dispatchEvent(new CustomEvent('tt:support-team', { detail: { team: key } }));
  }

  var timer = null;
  function tick() {
    var key = teamAt(now());
    if (key !== current) apply(key);
    clearTimeout(timer);
    /* Wake exactly at the next switch, and at least once a minute in case the device slept or its clock changed. */
    timer = setTimeout(tick, Math.min(secondsToSwitch(now()) * 1000 + 250, 60000));
  }

  function simulate(hhmmss) {
    if (hhmmss == null) {
      offset = 0;
    } else {
      var p = String(hhmmss).split(':');
      var target = (+p[0] || 0) * 3600 + (+p[1] || 0) * 60 + (+p[2] || 0);
      var diff = target - pkSeconds(Date.now());
      offset = diff * 1000 - (Date.now() % 1000);
    }
    tick();
    return current;
  }

  window.TTSupport = {
    timeZone: TZ,
    teams: TEAMS,
    pkSeconds: pkSeconds,
    teamAt: teamAt,
    secondsToSwitch: secondsToSwitch,
    simulate: simulate,
    refresh: tick,
    current: function () { return current; }
  };

  function init() {
    var theme = window.Shopify && window.Shopify.theme;
    var preview = (window.Shopify && window.Shopify.designMode) || (theme && theme.role && theme.role !== 'main');
    var q = location.search;
    try { q = decodeURIComponent(q); } catch (e) {}
    var m = preview && /[?&]tt_pkt=(\d{1,2}(?::\d{2}){0,2})/.exec(q);
    if (m) simulate(m[1]); else tick();
    document.addEventListener('visibilitychange', function () { if (!document.hidden) tick(); });
    window.addEventListener('pageshow', tick);
    window.addEventListener('focus', tick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
